// extracted by mini-css-extract-plugin
export default {"container":"Register_container__gTYhe","form":"Register_form__yJ1-d"};